import React from 'react';

import { Grid, makeStyles, Typography } from '@material-ui/core';

const useStyles = makeStyles((theme) => ({
  typographyLoadingText: {
    color: theme.palette.primary.main,
    fontSize: '12px',
    fontWeight: '500',
    lineHeight: '20px',
    marginBottom: '8px',
  },
}));

export default ({ progress }) => {
  const classes = useStyles();

  return (
    <Grid container justify="space-between">
      <Grid item>
        <Typography className={classes.typographyLoadingText}>Uploading Files</Typography>
      </Grid>
      <Grid item>
        <Typography className={classes.typographyLoadingText}>{progress}% Complete</Typography>
      </Grid>
    </Grid>
  );
};
